import React, { useMemo } from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import FitnessProfileReadingActions from '../shared/FitnessProfileReadingActions';
import FitnessProfileGoalProgressList from '../FitnessProfileGoalProgressList';

export default function FitnessProfileGoalsSection({ canEdit, goals, onManage, onAdd, onUpdateProgress }) {
	const activeGoals = useMemo(
		() => (goals || []).filter((goal) => goal.status !== 'archived'),
		[goals]
	);
	const hasGoals = activeGoals.length > 0;

	return (
		<FitnessProfileSectionCard
			title="Goals"
			subtitle="Progress to target outcomes"
			headerAction={
				canEdit ? (
					<FitnessProfileReadingActions
						onEdit={hasGoals ? onManage : undefined}
						onAdd={onAdd}
						editAriaLabel="Manage goals"
						editTitle="Manage goals"
						addAriaLabel="Add goals"
						addTitle="Add goals"
					/>
				) : null
			}
		>
			<FitnessProfileGoalProgressList
				goals={goals}
				canEdit={canEdit}
				onUpdateProgress={onUpdateProgress}
			/>
		</FitnessProfileSectionCard>
	);
}
